<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.0625 13.0626C8.0625 12.5448 8.48223 12.1251 9 12.1251C9.51777 12.1251 9.9375 12.5448 9.9375 13.0626C9.9375 13.5803 9.51777 14.0001 9 14.0001C8.48223 14.0001 8.0625 13.5803 8.0625 13.0626Z"
            class="fill-current" />
        <path
            d="M9 10.7481C9.34518 10.7481 9.625 10.4683 9.625 10.1231L9.625 4.6231C9.625 4.27793 9.34518 3.9981 9 3.9981C8.65482 3.9981 8.375 4.27793 8.375 4.62311L8.375 10.1231C8.375 10.4683 8.65482 10.7481 9 10.7481Z"
            class="fill-current" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.75 9C17.75 4.16751 13.8325 0.25 9 0.25C6.67936 0.25 4.45376 1.17187 2.81282 2.81282C1.17187 4.45376 0.25 6.67935 0.25 9C0.25 13.8325 4.16751 17.75 9 17.75C13.8325 17.75 17.75 13.8325 17.75 9ZM16.5 8.99909C16.5 4.85695 13.1421 1.49908 9 1.49908C7.01088 1.49908 5.10322 2.28926 3.6967 3.69578C2.29018 5.10231 1.5 7.00996 1.5 8.99908C1.5 13.1412 4.85786 16.4991 9 16.4991C13.1421 16.4991 16.5 13.1412 16.5 8.99909Z"
            class="fill-current" />
    </svg>
</template>
